import { Mesh, MeshBasicMaterial } from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { VRObject3D } from './VRObject3D';
import { chairCircleGeometry, chairPlaneGeometry } from './helpers/texturesAndGeometries';
import { stringToHexColor } from './helpers/colors';

class VRModel extends VRObject3D {
  constructor(containerName, camera, texture, x, y, z, model) {
    super(containerName, camera, texture, x, y, z, model);
    this.model = model;
    const scene = this;

    // Add a placeholder mesh while the OBJ file loads
    this.mesh = new Mesh(this.model.editMode ? chairPlaneGeometry : chairCircleGeometry, this.material);
    this.mesh.visible = false;
    this.mesh.type = '3dmodel';
    this.mesh.name = '3dmodel';
    this.name = '3dmodel';
    this.add(this.mesh);

    // Load the .obj file

    const objLoader = new OBJLoader();
    const url = 'virtualRealityFiles/models/house interior.obj'; // Replace with the path to your .obj file
    objLoader.load(
      url,
      (object) => {
        object.scale.set(0.01, 0.01, 0.01); // Adjust the scale as needed
        scene.add(object); // Add the loaded object to the scene
        object.children.forEach(mesh => {
          // Generate a random color
          const randomColor = Math.floor(Math.random() * 16777215).toString(16);

          // Create a material with the random color
          const randomColorMaterial = new THREE.MeshBasicMaterial({ color: `#${randomColor}` });
          mesh.material = randomColorMaterial
        })
        animate();
      },
      (xhr) => {
        console.log((xhr.loaded / xhr.total) * 100 + '% loaded'); // Optional: track loading progress
      },
      (error) => {
        console.error('An error occurred while loading the .obj file:', error);
      }
    );

    return this;
  }
}

export default VRModel;
